// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31cyZ","colBig":"styles_colBig__2bMvw","colSmall":"styles_colSmall__3KZ5c"};